import React from 'react';

import { faBuildingCircleXmark } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type Props = {
  title: string;
  subtitle?: string;
}

export function EmptyState({ title, subtitle }: Props) {
  return (
    <>
      <div className="text-center py-6">
        <FontAwesomeIcon className="text-muted" icon={faBuildingCircleXmark} size="3x" />
      </div>
      <h4 className="text-center m-0">{title}</h4>
      {subtitle && <p className="text-center">{subtitle}</p>}
    </>
  );
}
